export default "__VITE_ASSET__DwtuVtL8__"